import React from 'react';

import { condClass } from 'app/utils/general';

import classes from './MInput.module.scss';

interface Props {
  innerRef?: React.RefObject<HTMLInputElement>;
  className?: string;
  type?: string;
  label?: string;
  name?: string;
  value?: string | number;
  defaultValue?: string;
  valid?: boolean;
  invalid?: boolean;
  errorLabel?: string;
  onBlur?: (event: React.FocusEvent) => void;
  onChange?: (event: React.ChangeEvent<HTMLInputElement>) => void;
}

const MInputView: React.FC<Props> = (props: React.PropsWithChildren<Props>) => {
  return (
    <div className={condClass({ [classes['container']]: true, [String(props.className)]: !!props.className })}>
      <div className={condClass({ [classes['content']]: true, [classes['invalid']]: !!props.invalid })}>
        <input
          ref={props.innerRef}
          type={props.type}
          name={props.name}
          defaultValue={props.defaultValue}
          value={props.value}
          onChange={props.onChange}
          autoComplete="off"
          className={classes['input']}
          onBlur={props.onBlur}
          required
        />
        <label htmlFor="name" className={classes['label']}>
          <span className={classes['label__content']}>{props.label}</span>
        </label>
      </div>
      {props.invalid ? (
        <label className={classes['errorLabel']}>
          <span className={classes['errorLabel__text']}>{props.errorLabel}*</span>
        </label>
      ) : null}
    </div>
  );
};

MInputView.displayName = 'MInputView';
MInputView.defaultProps = {};

export default MInputView;
